import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OutletModule, PageLayoutComponent, PageLayoutModule, PageSlotModule} from '@spartacus/storefront';
import {DcpPageLayoutComponent} from './page-layout.component';

@NgModule({
  imports: [CommonModule, PageSlotModule, OutletModule, PageLayoutModule, DcpPageLayoutComponent],
  exports: [DcpPageLayoutComponent],
  providers: [{provide: PageLayoutComponent, useExisting: DcpPageLayoutComponent}],
})
export class DcpPageLayoutModule {}
